import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useSession } from "../utils/Session";
import { Button, Drawer, Avatar } from "antd";
import { UserOutlined } from "@ant-design/icons";
import PermissionSelector from "./PermissionSelector";
import AccessiblePopover from "./AccessiblePopover";
import { apiCall } from "../utils/Api";

function AccountBox(props) {

  const { avatar_color = "" } = props;
  const history = useHistory();
  const [session, setSession] = useSession();
  const [popOverVisible, setPopOverVisible] = useState(false);

  const dismiss = () => {
    setPopOverVisible(false);
    setVisible(false);
  };

  const handlePopOverVisibleChange = (visible) => {
    setPopOverVisible(visible);
  };

  const [visible, setVisible] = useState(false);

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  const onLogout = (_status, _result) => {
    if (_status) {
      setSession(_result);
      window.location.reload();
    } else {
      setSession({
        session_id: "",
        logged_in: false,
        user: [],
        cart: [],
      });

    }
  };

  const logout = () => {
    setPopOverVisible(false);
    apiCall("account/logout", {}, onLogout);
  };

  const getInitals = () => {
    let _f = session.user.first_name.substr(0, 1);
    let _l = session.user.last_name.substr(0, 1);
    return _f + _l;
  };

  const loginForm = (
    <div style={{ minWidth: "180px", "maxWidth" : "250px" }}>
      <PermissionSelector dismiss={dismiss} />
      <Button aria-label="Account Details" onClick={() => { dismiss(); history.push("/account/details"); }} style={{ width: "100%", marginBottom: "10px" }}>
        Account Details
      </Button>

      {(session?.edit_perms &&

        <Button aria-label="Permissions" onClick={() => { dismiss(); history.push("/account/permissions"); }} style={{ width: "100%", marginBottom: "10px" }}>
          Permissions
        </Button>
      )}

      <Button aria-label="Logout" onClick={() => { dismiss(); logout(); }} style={{ width: "100%" }} type="danger">
        Log out
      </Button>
    </div>
  );


  const name = session.user.is_institution && session.user.company ? session.user.company : session.user.first_name


  return (
    <div>
      {/* Desktop Popover */}
      <AccessiblePopover
        open={popOverVisible}
        onOpenChange={handlePopOverVisibleChange}
        title="Account"
        overlayClassName="fixed"
        className="hide"
        trigger="click"
        content={loginForm}
        placement="bottomRight"
        icon={<UserOutlined aria-hidden />}
        label={name}
      />

      {/* Mobile Drawer */}
      <div className="show">
        <Avatar
          style={{
            marginTop: "0px",
            cursor: "pointer",
            backgroundColor: "#ffffff11",
            color: avatar_color,
            boxShadow: "0px 0px 0px 1px #00000011",
          }}
          onClick={showDrawer}
          className="bm-icon"
          size={28}
          aria-expanded={visible} // Announce expanded state
          aria-controls="account-drawer" // Associate button with drawer
        >
          <div style={{ marginTop: "0px" }}>{getInitals()}</div>
        </Avatar>
        <Drawer
          placement="bottom"
          title={session.user.first_name + " " + session.user.last_name}
          height="380px"
          mask={false}
          onClose={onClose}
          open={visible}
        >
          <div style={{ backgroundColor: "#fff", padding: "20px" }}>
            {loginForm}
            <br />
          </div>
        </Drawer>
      </div>
    </div>
  );
}

export default AccountBox;
